import React, { Component } from 'react';
import { GenericOption, GenericSelect } from 'com-gyf-webcore-userinterfacecomponents';

class PopUpProducto extends Component {
    constructor(props) {
        super(props);

        this.state = {
            productoId: ""
        }
    }

    productoSelectedSave = () => {
        this.props.productoSelectedSave(this.props.productos.menuUsuario, this.props.productoId);
    }

    componentDidMount() {

        if (!this.props.startUpSelected || this.props.flagAccesoDirecto)
            this.props.showPopUp();
    } 

    componentWillReceiveProps(nextProps) {
        this.setState({
            productoId: nextProps.productoId ? nextProps.productoId : 0
        });

        if (nextProps.productos.programCategories &&
            nextProps.productos.programCategories.length > 0 &&
            !nextProps.productos.categorySelected) {

            this.props.showPopUpPrograma();
        }


        if (this.props.defaultProducto) {
            this.productoSelected(this.props.defaultProducto.ProductoId);
            this.props.productoSelectedSave(this.props.productos.menuUsuario, this.props.defaultProducto.ProductoId);
        }
    }

    close = (path) => {
        window.location.replace(path);
    }

    clean = () => {
        this.setState({ productoId: ""});
    }

    productoSelected = (e) => {
        this.props.productoSelected(e);
    }
    
    render() {
        const { props } = this;

        let selec;
        let products = this.props.productos.menuUsuario;
        let primerLogin = this.props.primerLogin;
        let startUp = this.props.startUpSelected;

        let oProducto = products.map((product) => {
            selec = product.id == this.state.productoId ? true : false;
            return (<div className="row row-radio">
                        <div className="left-separator-xs panel panel-view">

                    <div className="container-radio-popup radio-margin panel-view-radio">
                                <input id={"NewProduct_" + product.id} type="radio" name="groupX1" checked={selec} />
                                <label className="lbl-radio label-secondary panel-view-label level-auxiliary" onClick={() => this.productoSelected(product.id)}>
                                    <p>{product.codigo}</p>
                                    <span> </span>
                                </label>
                            </div>
                        </div>
                    </div>)
        });

        return (
            <div className="modal fade-out" id="productoModal" role="dialog" data-backdrop="static">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header modal-header-onboarding" data-label="Título">
                            {(primerLogin) &&
                                (<div className="close" data-dismiss="modal" aria-hidden="true">
                                <label className="ti-close clickable" onClick={() => this.close(startUp)}></label>
                                </div>)
                            }

                            <h4 className="modal-title">Seleccione un producto de inicio</h4>
                            <h5>Por favor, seleccione a que producto desea acceder cada vez que inicie sesión:</h5>
                        </div>

                        <div className="modal-body modal-perfiles-body">
                            <div className="row">
                                {oProducto}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <div className="row">
                                <div className="col-xs-5">
                                    <button type="button"
                                        className="btn btn-primary btn-cta"
                                        onClick={this.productoSelectedSave}>Seleccionar Producto</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PopUpProducto;


// WEBPACK FOOTER //
// ./Portico/App/Screens/TopMenu/PopUpProducto.jsx